// import { getEnvs } from '@/shared/utils';
// const { VITE_BUCKET_BASE } = getEnvs();
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS,
  emptyCellOneLevel,
  formatDate,
  hasAllPermissions,
  useCheckPermissions,
  useTableServerSideFiltering,
} from "@/shared";
import { useDeleteIpv4, useFetchIpv4 } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { Ipv4 } from "@/shared/interfaces";
import { useUiConfirmModalStore } from "@/store/ui";

export type IPV4PageProps = {};

const IPV4Page: React.FC<IPV4PageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ipv4);

  const returnUrlIpv4Page = ROUTER_PATHS.configuracionRED.ipv4Nav;

  const navigate = useNavigate();

  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  const deleteIpv4 = useDeleteIpv4();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();
  const { filterObject, columnFilters, setColumnFilters } =
      useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: Ipv4PagingRes,
    isLoading,
    isRefetching,
  } = useFetchIpv4({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ip: searchTerm,
      ...filterObject,
    },
  });

  ///* handlers

  const onEdit = (ipv4: Ipv4) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar Ipv4",
      subtitle: "¿Está seguro que desea editar este Ipv4?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrlIpv4Page}/editar/${ipv4.id_ipv4}`);
      },
    });
  };

  const onDelete = (ipv4: Ipv4) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar Ipv4",
      subtitle: "¿Está seguro que desea eliminar este Ipv4?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteIpv4.mutate(ipv4.id_ipv4!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<Ipv4>[]>(
    () => [
      {
        accessorKey: "grupo_ipv4",
        header: "Grupo IPV4",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "grupo_ipv4"),
      },
      {
        accessorKey: "ip",
        header: "Direccion IP",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "ip"),
      },
      {
        accessorKey: "estado_ip",
        header: "Estado IPV4",
        size: 180,
        // Cell: ({ row }) => emptyCellOneLevel(row, "estado_ip"),
        enableColumnFilter: true,
        filterVariant: "select",
        filterSelectOptions: [
          { value: "DISPONIBLE", label: "Disponible" },
          { value: "NO DISPONIBLE", label: "No Disponible" },
          { value: "EN MANTENIMIENTO", label: "En Mantenimiento" },
          { value: "RESERVADO", label: "Reservado" },
          { value: "EN USO", label: "En Uso" },
        ],
      },
      {
        accessorKey: "contrato",
        header: "Contrato",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "contrato"),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha Modificación",
        size: 180,
        Cell: ({ row }) => formatDate(row.original?.fecha_modificacion||""),
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        size: 180,
        Cell: ({ row }) => formatDate(row.original?.fecha_creacion||""),
      },
    ],
    []
  );

  //CUSTOM HOOKS

  // const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();

  return (
    <SingleTableBoxScene
      title="IPV4"
      urlRedirect={`${returnUrlIpv4Page}/crear`}
      enableRedirect={hasAllPermissions([
        PermissionsEnum.api_add_ipv4,
      ])}
      //excel
      // enableUploadFile={true}
      // enableDownloadFile={true}
      // fileInputRef={importOLTs}
      // importationName={"Subir OLTs"}
      // handleFileUpload={handleImportarOLT}
      // importationsQuantity={1}
      // urlDownloadPlantilla={
      //   "/"+VITE_BUCKET_BASE+plantillaExcelENUM.PLANTILLA_OLT
      // }
      // urlDownloadNameExcel={"plantilla_olt"}
    >
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por dirección IP"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<Ipv4>
        columns={columns}
        data={Ipv4PagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={Ipv4PagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // actions ========
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_ipv4,
        ])}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_ipv4,
        ])}
        onEdit={onEdit}
        canDelete={false}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
};

export default IPV4Page;
